import script from "./UserHeaderTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserHeaderTotals.vue?vue&type=script&setup=true&lang=ts"

import "./UserHeaderTotals.vue?vue&type=style&index=0&id=57913000&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57913000"]])

export default __exports__